import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official'
import { Block } from "@material-ui/icons";

//Highcharts.seriesType.line.prototype.drawLegendSymbol = Highcharts.seriesType.column.prototype.drawLegendSymbol;
// console.log(Highcharts.seriesType);

class OrgResultChart extends Component <any>{
  private chartComponent: any;
  constructor(props){
    super(props);
    this.chartComponent = React.createRef();
  }

  componentDidMount() {
    const container = this.chartComponent.current.container.current;
    var ele = window.innerWidth;
    var eleWidth = ((ele-0.2*ele));
    let chartWidth = (eleWidth - eleWidth*0.53);
    if( document.getElementById('contentTd').clientWidth < 100){
      chartWidth = chartWidth + 120; //Need to uncomment after we fix rerender component on open or close sidebar
    }
    let grHeight = 380;
    if(!this.props.options.series[2].showInLegend){
       grHeight = (grHeight-15);
    }
     container.style.height = grHeight+"px";
    this.chartComponent.current.chart.reflow();
  }

  render(){
    return (
      // <div className="chartContainer" id={this.props.container} style= {{ width: "430px", height: "300px"}} ></div> );
      <div className={`chartContainer ${(window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/')  > -1) ? "IE": ""}`}  style={{display: "block", maxHeight: "320px" }} >
        <HighchartsReact
        constructorType={"chart"}
        highcharts={Highcharts}
        options={this.props.options}
        oneToOne={true}
        ref={this.chartComponent}
         key={Math.floor(Math.random() * 10000000)+1}
        />
        </div>
    );
  }
};

export default React.memo(OrgResultChart);
